'use client';

import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

import { MemberProfilePage } from '@/features/team/components/member-profile-page';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/team/members/$userId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.teamMemberProfile'),
  }),
  component: TeamMemberProfileRoute,
});

function TeamMemberProfileRoute() {
  const navigate = useNavigate();
  const { userId } = useParams({
    from: '/_authenticated/settings/team/members/$userId',
  });

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-6xl">
        <MemberProfilePage
          userId={userId}
          onNavigateBack={() => {
            void navigate({ to: '/settings/team' });
          }}
        />
      </div>
    </div>
  );
}
